import { useEffect, useState } from 'react';

const CURRENCY_KEY_INPUT_ID = 'property_currency_key';
const DEFAULT_CURRENCY_LABEL = '$';

const readCurrencyLabel = (): string => {
  const input = document.getElementById(CURRENCY_KEY_INPUT_ID);
  if (input instanceof HTMLSelectElement) {
    const selectedOption = input.options[input.selectedIndex];
    const label = selectedOption?.text?.trim();
    if (label) return label;
  }
  return DEFAULT_CURRENCY_LABEL;
};

export const useCurrencyLabel = (): string => {
  const [currencyLabel, setCurrencyLabel] = useState<string>(() => readCurrencyLabel());

  useEffect(() => {
    const input = document.getElementById(CURRENCY_KEY_INPUT_ID);
    if (!input) return undefined;
    const onChange = () => setCurrencyLabel(readCurrencyLabel());
    input.addEventListener('change', onChange);
    return () => input.removeEventListener('change', onChange);
  }, []);

  return currencyLabel;
};
